module.exports = __webpack_public_path__ + "static/media/saudi.91e21502.jpg";